<template>
<!-- 公告 -->
  <section>
    <!--列表-->
    <template>
      <el-col :span="24" class="order_content main_container">
        <section class="model_section">
          <p class="model_top_title">消息中心</p>
          <el-button type="danger" @click="addNewlyBuild()" style="float: right;margin: 5px 10px 0 0;">新建</el-button>
        </section>
        <!-- table 列表 -->
        <div class="table_container">
          <div class="table_inner_container" style="height:auto">
            <el-table :data="dataList" class="invoice_tab" stripe border style="height:auto;max-height:500px">
              <el-table-column label="标题" align="center">
                <template scope="scope">
                  <span :title="scope.row.title">{{scope.row.title}}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" align="center">
                <template scope="scope">{{scope.row.publishTime}}</template>
              </el-table-column>
              <el-table-column label="摘要" align="center">
                <template scope="scope">{{scope.row.content}}</template>
              </el-table-column>
              <el-table-column label="详情" fixed="right" align="center">
                <template scope="scope">
                  <span @click="seeNotice(scope.row)" class="handle"> <i class="el-icon-view"/> 查看 </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
              :current-page="pageIndex" :page-size="10" :total="totalRowsCount"/>
          </el-col>
        </div>
      </el-col>
    </template>
    <!-- 通知-弹框 -->
    <el-dialog :title="titleType" :visible.sync="isToExamine" :center="true" width="30%">
      <el-form>
        <el-form-item label="标题 :" style="width:80%" label-width="80px">
          <el-input :disabled="seeDis" v-model="brandName" placeholder="请输入通知的标题，「限制30个字符」" maxlength="30"/>
        </el-form-item>
        <el-form-item label="发布时间 :" style="width:80%" label-width="80px" v-if="titleType == '详情'">
          <el-input :disabled="seeDis" v-model="fabuTime"/>
        </el-form-item>
        <el-form-item label="内容 :" style="width:80%;" label-width="80px">
          <el-input type="textarea" v-model="anwser" placeholder="请输入通知的内容" :disabled="seeDis"
            :autosize="{ minRows: 3, maxRows: 8}" maxlength="200" show-word-limit/>
        </el-form-item>
      </el-form>
      <!-- 弹框按钮 -->
      <div class="btnDiv">
        <button type="button" @click="editSubmit()" v-if="titleType == '新建通知'" class="el-button search_btn normal_btn">发布</button>
        <button type="button" @click="endRefuse()" v-if="titleType == '详情'" class="el-button cancle">关闭</button>
      </div>
    </el-dialog>
    
    <!-- 发布-弹框 -->
    <el-dialog title="提示" :visible.sync="seeFb" :center="true" width="30%" append-to-body>
      <el-form>
        <el-form-item label="标题 :" style="width:80%" label-width="120px">
          <b>{{echoTitle}}</b>
        </el-form-item>
        <el-form-item label="发布时间 :" style="width:80%" label-width="120px">
          <b>{{releaseTime}}</b>
        </el-form-item>
      </el-form>
      <div style="text-align:center">
        <el-button type="danger" @click="rejectToExamine()">确定</el-button>
        <el-button @click="seeFb = false">取消</el-button>
      </div>
    </el-dialog>

  </section>
</template>
<script>
import { getBack, getDetailBack, postBack} from "../../api/attractInvestment";
export default {
  name: 'noticeList',
  data() {
    return {
      rooid: "",
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      isToExamine: false, // 弹框
      titleType: "新建通知",
      brandName: "", // 标题
      fabuTime: "", // 发布时间
      anwser: '', // 内容
      seeDis: false, // 置灰

      seeFb: false, // 发布提示弹框
      echoTitle: "", // 确认标题
      releaseTime: new Date(), // 发布时间
      timer: "", // 定时器
    }
  },
  methods: {
    //查询列表
    getInit() {
      let addParams = {
        pageIndex: this.pageIndex,// 当前页码
        pageSize: this.pageSize // 每页显示条数
      };
      getBack(addParams).then(data => {
        this.dataList = data.resultObj.resultObj;
        this.totalRowsCount = data.resultObj.rowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 新建
    addNewlyBuild() {
      this.isToExamine = true; // 详情弹框展示
      this.titleType = "新建通知";
      this.brandName = "", // 标题
      this.anwser = "", // 内容
      this.seeDis = false;
    },
    // 查看
    seeNotice(row) {
      this.rooid = row.id;
      this.isToExamine = true;
      this.titleType = "详情";
      this.seeDis = true;
      // 查询公告详情
      var addParams = {
        id: this.rooid
      };
      getDetailBack(addParams).then(data => {
        this.brandName = data.resultObj.title; // 公告标题
        this.fabuTime = data.resultObj.publishTime; // 发布时间
        this.anwser = data.resultObj.content; // 公告摘要
      })
    },
    // 发布
    editSubmit() {
      if (this.brandName == "") {
        this.$swal({
          type:"warning",
          text:"请输入标题"
        })
        return false;
      }
      if (this.anwser == "") {
        this.$swal({
          type:"warning",
          text:"请输入公告内容"
        })
        return false;
      }
      this.echoTitle = this.brandName; // 标题赋值
      this.seeFb = true;
    },
    // 确认发布
    rejectToExamine() {
      // 新增公告
      var loginParams = {
        publisher: localStorage.Id, // 当前操作人id
        title: this.brandName, // 公告标题【必填】
        content: this.anwser, // 公告内容【必填】
      };
      postBack(loginParams).then(data => {
        if (data.ResultCode == 1) {
          this.$swal({
            text:"添加成功",
            type: "success"
          })
          this.seeFb = false; // 发布提示弹框
          this.isToExamine = false;
          this.getInit();
        }
      })
    },
    // 关闭
    endRefuse() {
      this.isToExamine = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
  },
  created() {
    this.getInit(); // 查询列表
    // 获取发布时间 - 实时
    var _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(function() {
      _this.releaseTime = // 修改数据date
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
    }, 1000);
  },
  // 在Vue实例销毁前，清除定时器
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>
<style scoped>
.btnDiv {
  width: 100%;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// noticeList.vue?0b5d106c